wbApp.controller('EmailTemplateLoadDialogCtrl', ['$scope', '$translate', '$filter', 'messageTemplateSvc',
    function ($scope, $translate, $filter, messageTemplateSvc) {

        $scope.templates = messageTemplateSvc.getAllInfo();
        $scope.selectedTemplate = null;

        $scope.onRowSelected = function (model) {
            $scope.selectedTemplate = model;
        }

        $scope.gridSettings = {
            name: 'templates',
            keyExpr: 'id',
            shouldDisableDelete: function(row) {return false; },
            columns: [
                { dataField: 'id', caption: $translate.instant('TXT_LBL_ID'), dataType: 'string', visible: false },
                { dataField: 'name', caption: $translate.instant('TXT_LBL_NAME'), dataType: 'string' },
                {
                    dataField: 'updatedAtUtc',
                    caption: $translate.instant('TXT_LBL_UPDATED_AT'),
                    dataType: 'date',
                    format: { type: 'shortDateShortTime' },
                    width: '140px',
                    sortOrder: 'desc'
                },
            ]
        }

        $scope.onRowDelete = function (model) {
            messageTemplateSvc.remove(model.id).$promise.then(function () {
                $scope.selectedTemplate = null;
                $scope.templates = messageTemplateSvc.getAllInfo();
            });
        }

        $scope.loadTemplate = function () {
            messageTemplateSvc.getById($scope.selectedTemplate.id).$promise.then(function (model) {
                $scope.onLoad(model);
            });
        }
}]);
